<template>
  <div
    class="rounded-full text-1316 bg-chinese-black opacity-75 text-white w-10 h-10 flex items-center justify-center hover:opacity-100 cursor-pointer"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <template v-if="!hover">
      {{ scale }}x
    </template>
    <wui-icon
      v-else
      data-test="scale-icon"
      small
      name="zoomMinusM"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { ref } from 'vue'

defineProps<{
  scale: number
}>()

const hover = ref(false)
</script>
